<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>About Team </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm about-us section-banner-bg-1">
    <div class="container">
        <div class="widget_title inner-title">
            <h4>ABOUT TEAM</h4>
        </div>
        <div class="categories-area">
            <div class="row g-3 row-cols-1 row-cols-sm-2 row-cols-lg-3 justify-content-center align-items-center">
                <div class="col ">
                    <div class="cat-item shadow-soft">
                        <h3 class="text-center"> Seema Vivek Wanjari</h3>
                        <p class="text-center"> Director </p>
                    </div>
                </div>
                <div class="col">
                    <div class="cat-item shadow-soft">
                        <h3 class="text-center">Aarti Pradyumna Deshpande </h3>
                        <p class="text-center">Director</p>
                    </div>
                </div>
                <div class="col">
                    <div class="cat-item shadow-soft">
                        <h3 class="text-center">Dr. Mrunalini Naik</h3>
                        <p class="text-center">Director</p>
                    </div>
                </div>

                <div class="col">
                    <div class="cat-item shadow-soft">
                        <h3 class="text-center">Indrajeet Singh Randhawa </h3>
                        <p class="text-center mb-0">Physical Director</p>
                        <p class="text-center">G H Raisoni College of Engineering, Nagpur</p>
                    </div>
                </div>
                <div class="col">
                    <div class="cat-item shadow-soft">
                        <h3 class="text-center">Mr. Amit Gandhare</h3>
                        <p class="text-center">PR Director</p>
                    </div>
                </div>
                <div class="col">
                    <div class="cat-item shadow-soft">
                        <h3 class="text-center"> Mr Akhil Rambhad</h3>
                        <p class="text-center">Sports Coordinator</p>
                    </div>
                </div>

                <div class="col">
                    <div class="cat-item shadow-soft">
                        <h3 class="text-center">Shubhangi Thakre</h3>
                        <p class="text-center">Executive</p>
                    </div>
                </div>
                <div class="col">
                    <div class="cat-item shadow-soft">
                        <h3 class="text-center">Deepali Poriaya</h3>
                        <p class="text-center">Executive</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
